"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var lesson_plan_requirements_controller_1 = __importDefault(require("./lesson-plan-requirements.controller"));
var lesson_plan_requirements_html_1 = __importDefault(require("./lesson-plan-requirements.html"));
var roadmap_resolves_1 = require("../../../../roadmaps/roadmap-resolves");
function getLessonPlans(LessonPlanModel) {
    return LessonPlanModel.get({ paging: 0 }).then(function (response) {
        return response.lesson_plans;
    });
}
getLessonPlans.$inject = ["LessonPlanModel"];
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes;
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes;
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.requirements", {
        url: "/requirements",
        controller: lesson_plan_requirements_controller_1.default,
        controllerAs: "vm",
        template: lesson_plan_requirements_html_1.default,
        resolve: {
            courseTypes: getCourseTypes,
            sessionTypes: getSessionTypes,
            lessonPlans: getLessonPlans,
            documentTemplates: roadmap_resolves_1.getDocumentTemplates,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.requirements", [])
    .config(config)
    .controller("AdminStudentViewRequirementsController", lesson_plan_requirements_controller_1.default);
